<template>
  <div class="main" id="" style="color:white">
    <div
      style="height:40px;line-height:40px;padding-left:10px;border: 1px solid #009393;font-size:20px;text-align: left;color:#009393">
      TC3
    </div>
    <div class="detail_left" style="float:left;width:28%;height:90%;border: 1px solid #022633;">
      <div style="color:#009393;margin:25px 0 0 20px;font-size:16px;">Operator
        <div class="drive1" style="margin-top:30px;color: white">
          <div class="tcspan">Name：Md Mohiddin</div>
          <div class="tcspan">Age：</div>
          <div class="tcspan">License：S7563665B</div>
        </div>
        <div class="drive2" style="margin-top:30px;color: white">
          <div class="tcspan">Name：Wu Gui Wu</div>
          <div class="tcspan">Age：</div>
          <div class="tcspan">License：S9074560C</div>
        </div>
      </div>
      <div style="color:#009393;font-size:16px;margin:25px 0 0 20px;">Tower Crane
        <div class="tower1" style="margin-top:30px;color: white">
          <div class="tcspan">Name：TC3</div>
          <div class="tcspan">SN：011916060052</div>
          <div class="tcspan">Front Axle Length：32m</div>
          <div class="tcspan">Rope Axle Length：12m</div>
          <div class="tcspan">Front Pull Rod Distance：32m</div>
          <div class="tcspan">Height：20m</div>
          <div class="tcspan">Hat Height：9m</div>
          <div class="tcspan">Max Load：12t</div>
        </div>
      </div>

    </div>
    <!--<div class="circle3">-->
    <!--<div class="line3">-->
    <!--<hr style="height:2px;background:rgba(255,255,255,0.5);border-width: 0"/>-->
    <!--</div>-->
    <!--</div>-->
    <div calss="detail_middle" style="float:left;width:35%;height:90%;margin-left: 50px;">
      <img class="towercrane_image" src="../../assets/tower-crane.png"/>
    </div>
    <div class="detail_right" style="float:left;width:25%;height:90%;border: 1px solid #022633;">
      <div style="color:#009393;font-size:16px;margin:25px 0 0 20px;">Real-time Information
        <div class="tower1" style="margin-top:30px;color: white">
          <div class="tcspan">Rotation
            Angle：{{ parseInt(rundata.rotationAngle) ? rundata.rotationAngle + "°" : "N.A." }}
          </div>
          <div class="tcspan">Radius：{{ parseInt(rundata.radius) ? parseInt(rundata.radius) + "°" : "N.A." }}</div>
          <div class="tcspan">Height：{{ parseInt(rundata.height) }}</div>
          <div class="tcspan">Load
            Value：{{ parseInt(rundata.loadValue) ? parseInt(rundata.loadValue) + "t" : "N.A." }}
          </div>
          <div class="tcspan">Safe Load：{{ parseInt(rundata.safeLoad) ? parseInt(rundata.safeLoad) + "t" : "N.A." }}
          </div>
          <div class="tcspan">Wind
            Speed：{{ parseInt(rundata.windSpeed) ? parseInt(rundata.windSpeed) + "m/s" : "N.A." }}
          </div>
          <div class="tcspan">Alarm：{{ parseInt(rundata.alarm) ? parseInt(rundata.alarm) : "N.A." }}</div>
          <div class="tcspan">Obliquity：{{ parseInt(rundata.obliquity) ? parseInt(rundata.obliquity) : "N.A." }}</div>
          <div class="tcspan">Power
            Quantity：{{ parseInt(rundata.powerQuantity) ? parseInt(rundata.powerQuantity) : "N.A." }}
          </div>
          <div class="tcspan">Input State：{{ parseInt(rundata.inputState) ? parseInt(rundata.inputState) : "N.A." }}
          </div>
          <div class="tcspan">Warning：{{ parseInt(rundata.warning) ? parseInt(rundata.warning) : "N.A." }}</div>
          <div class="tcspan">Peccancy：{{ parseInt(rundata.peccancy) ? parseInt(rundata.peccancy) : "N.A." }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "detail",
  props: ['rundata'],

  data() {
    return {
      legendArr: [],
      color: this.$store.state.color.dashboard_color,
      name: 'Construction Site',
    }
  },
  methods: {}
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.towercrane_image {
  /*width:35%*/
  height: 85%
  position: relative;
  /*border :1px solid red;*/
  padding-top: 40px
  /*float:left*/
}

.detail_left {
  margin: 20px 0 0 10px;
  background: linear-gradient(#31334a, #000000);
}

.detail_right {
  margin: 20px 0 0 50px;
  background: linear-gradient(#31334a, #000000);
}

.circle3 {
  position: absolute;
  right: 410px;
  top: 480px;
  z-index: 50;
  transition: all 5s ease-in-out 0s;
  width: 180px;
  height: 180px;
  border: 3px solid white;
  border-radius: 50%;
  /*opacity: 0.3;*/
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg); /* Safari �� Chrome */
}

.line3 {
  margin-top: 90px;
  margin-left: 90px;
  width: 90px;
}

.tcspan {
  margin: 10px 0 0 40px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/towercrane/detail.vue